import { ViewportScroller } from '@angular/common';
import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { filter, map, tap } from 'rxjs/operators';

import { checkForceViewAttachmentsUseCase, getForcedGridTypeUseCase } from '../../application/use-cases/category-grid.use-cases';
import { LoadCategorySuccess } from '../category-page.actions';
import { getCategory } from '../category-page.selectors';

import { ChangeGridType, SetGridTypeSuccess } from './grid-type.actions';
import { getGridType } from './grid-type.selectors';

import { Category } from '@core/domain/models/category.models';
import { CorePlatformService } from '@core/infrastructure/platform/platform.service';
import { GridTypes } from '@shared/models/grid-type.model';

@Injectable()
export class GridTypeEffects {
    private readonly platform = inject(CorePlatformService);

    private readonly actions$ = inject(Actions);

    private readonly viewportScroller = inject(ViewportScroller);

    private readonly store = inject(Store);

    private readonly getStorageGridType$$ = this.store.selectSignal(getGridType);

    private readonly getCategory$$ = this.store.selectSignal(getCategory);

    public onChangeCategory$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(LoadCategorySuccess),
            map(() => this.getGridTypeClient()),
            map((gridType: number) => {
                const gridTypeCategory = this.getGridTypeByCategory(this.getCategory$$());
                return SetGridTypeSuccess({ gridType: gridTypeCategory ?? gridType, gridTypeCategory });
            }),
        );
    });

    public changeGridType$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(ChangeGridType),
            map(({ gridType }) => {
                return SetGridTypeSuccess({ gridTypeCategory: null, gridType });
            }),
        );
    });

    public onChangeGridType$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(SetGridTypeSuccess),
            filter(() => this.platform.isBrowser()),
            // Cada cambio de GRID posicionamos la Vista al Top de la página
            tap(() => { this.viewportScroller.scrollToPosition([0, 0]); }),
        );
    }, { dispatch: false });

    private getGridTypeByCategory(category: Category): number {
        const attachment = checkForceViewAttachmentsUseCase(category);
        return getForcedGridTypeUseCase(attachment);
    }

    private getGridTypeClient(): GridTypes {
        const gridTypeStore = this.getStorageGridType$$();
        if (gridTypeStore) return gridTypeStore;

        return GridTypes.GRID_4;
    }
}
